"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSONAS_UNTITLED_GROUP = exports.PERSONAS_DELETE_TOOLTIP = exports.PERSONAS_PAGE_DESCRIPTION = exports.PERSONAS_BADGE_LABELS = void 0;
exports.PERSONAS_BADGE_LABELS = {
    predefined: 'Predefined',
    'ai-generated': 'AI Generated',
};
exports.PERSONAS_PAGE_DESCRIPTION = 'Curate the persona groups that organize the user personas extracted ' +
    'from your AI use cases. Personas themselves are read-only — they ' +
    'originate in the source use case definitions — so admins focus on ' +
    'grouping: create new groups (typically by business function), rename ' +
    'them, and reassign personas so every audience segment you report on is ' +
    'backed by a clean, well-named bucket. Click Save Changes to publish ' +
    'the grouping; AI-generated groups are flagged with a sparkles icon for ' +
    'traceability.';
exports.PERSONAS_DELETE_TOOLTIP = 'Only persona groups without any personas can be deleted. Move all ' +
    'personas out of a group before removing it.';
exports.PERSONAS_UNTITLED_GROUP = 'Untitled Group';
